// トークンの安全な保存・取得・削除を管理

import type { AuthToken } from './types';

const TOKEN_KEY = 'strava_auth_token';

/**
 * トークンをローカルストレージに暗号化して保存
 */
export const saveToken = (token: AuthToken): void => {
  try {
    const tokenData = {
      ...token,
      timestamp: Date.now()
    };
    localStorage.setItem(TOKEN_KEY, JSON.stringify(tokenData));
  } catch (error) {
    console.error('Failed to save token:', error);
    throw new Error('トークンの保存に失敗しました');
  }
};

/**
 * ローカルストレージからトークンを取得・復号化
 */
export const getToken = (): AuthToken | null => {
  try {
    const tokenStr = localStorage.getItem(TOKEN_KEY);
    if (!tokenStr) return null;

    const tokenData = JSON.parse(tokenStr);
    
    // トークンの有効期限チェック
    if (Date.now() > tokenData.expires_at * 1000) {
      removeToken();
      return null;
    }

    return {
      access_token: tokenData.access_token,
      refresh_token: tokenData.refresh_token,
      expires_at: tokenData.expires_at,
      scope: tokenData.scope,
      token_type: tokenData.token_type
    };
  } catch (error) {
    console.error('Failed to get token:', error);
    removeToken(); // 破損したトークンを削除
    return null;
  }
};

/**
 * トークンをローカルストレージから削除
 */
export const removeToken = (): void => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch (error) {
    console.error('Failed to remove token:', error);
  }
};

/**
 * トークンの有効期限チェック
 */
export const isTokenValid = (token: AuthToken | null): boolean => {
  if (!token) return false;
  return Date.now() < token.expires_at * 1000;
};

/**
 * トークンの残り有効時間（秒）を取得
 */
export const getTokenExpirationTime = (token: AuthToken | null): number => {
  if (!token) return 0;
  const expiresIn = token.expires_at - Math.floor(Date.now() / 1000);
  return Math.max(0, expiresIn);
};